import * as Loadable from 'react-loadable';
import LoadingPageLayout from '../loading/LoadingPageLayout';

const createLoadableComponent = (imp: any) => Loadable({
  loader: () => imp(),
  loading: LoadingPageLayout,
  delay: 300
});

export default createLoadableComponent


// WEBPACK FOOTER //
// ./src/common/LoadableComponent.tsx